import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b89c09ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "overflow-x": "auto",
    "flex": "1",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "height": "40px",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_5 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow-y": "auto",
    "flex": "1"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "margin-top": "20px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "105px",
    "min-width": "105px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "end",
    "padding-right": "10px",
    "font-size": "18px",
    "color": "#777777"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "Ongoing")], -1));
const _hoisted_8 = {
  style: {
    "display": "flex",
    "padding-left": "15px",
    "flex-wrap": "wrap",
    "border-left": "1px solid rgb(215, 212, 212)"
  }
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "activity-title-box"
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "position": "relative",
    "margin-top": "8px"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "top": "-5px",
    "left": "0px"
  }
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 0/0 ", -1));
const _hoisted_15 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "position": "relative",
    "margin-top": "8px"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "top": "-5px",
    "left": "0px"
  }
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "0/0", -1));
const _hoisted_18 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "position": "relative",
    "margin-top": "8px"
  }
};
const _hoisted_19 = {
  style: {
    "position": "absolute",
    "top": "-5px",
    "left": "0px"
  }
};
const _hoisted_20 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "position": "relative",
    "margin-top": "8px"
  }
};
const _hoisted_21 = {
  style: {
    "position": "absolute",
    "top": "-5px",
    "left": "0px"
  }
};
const _hoisted_22 = {
  class: "collapse"
};
const _hoisted_23 = {
  class: "collapse-header"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "font-size": "18px",
    "color": "#777777"
  }
}, " Completed ", -1));
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "collapse-content"
};
const _hoisted_27 = {
  key: 0,
  class: "collapse-content-item-line"
};
const _hoisted_28 = {
  key: 1,
  style: {
    "flex": "1",
    "display": "flex",
    "padding-left": "15px",
    "flex-wrap": "wrap",
    "overflow-y": "auto"
  }
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "activity-title-box"
};
const _hoisted_32 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "position": "relative",
    "margin-top": "8px"
  }
};
const _hoisted_33 = {
  style: {
    "position": "absolute",
    "top": "-5px",
    "left": "0px"
  }
};
const _hoisted_34 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "position": "relative",
    "margin-top": "8px"
  }
};
const _hoisted_35 = {
  style: {
    "position": "absolute",
    "top": "-5px",
    "left": "0px"
  }
};
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode, watch } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, notification } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
  __name: 'ActivityBrowser',
  setup(__props) {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用

    // 引入组件
    const components = {
      DownCircleOutlined,
      PlusOutlined
    };
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const activityBrowserRO = reactive({
      activityCategoryId: null,
      searchKeyword: null,
      isOngoing: true
    });
    const activityBrowserRO2 = reactive({
      activityCategoryId: null,
      searchKeyword: null,
      isOngoing: false
    });
    const activityData = reactive({
      ongoingItems: [],
      years: []
    });
    const selectActivityYear = ref(null);
    const activityBrowserData = reactive([]);
    const endActivityBrowserData = reactive([]);
    const endActivityYearData = reactive([]);
    const installedAnimated = reactive({});
    const progressAnimated = reactive({});
    function animate(obj, key, target) {
      const duration = 600; // 动画时长
      const start = obj[key] ?? 0;
      const startTime = performance.now();
      function run(now) {
        const p = Math.min((now - startTime) / duration, 1);
        obj[key] = Math.round(start + (target - start) * p);
        if (p < 1) requestAnimationFrame(run);
      }
      requestAnimationFrame(run);
    }

    // 监听列表数据
    watch(() => activityData.ongoingItems, list => {
      list.forEach(item => {
        animate(installedAnimated, item.activityId, item.installedProgress);
        animate(progressAnimated, item.activityId, item.progress);
      });
    }, {
      immediate: true,
      deep: true
    });
    const getActivityBrowser = async (activityBrowserRO, retry) => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityBrowser(activityBrowserRO, retry).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityBrowserPre = async (activityBrowserRO, retry) => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityBrowserPre(activityBrowserRO, retry).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    // const getEndActivityYear = async (activityBrowserRO, retry) => {
    //   return new Promise((resolve, reject) => {
    //     proxy.$api.activityRequest
    //       .getEndActivityYear(activityBrowserRO, retry)
    //       .then((res) => {
    //         resolve(res.result.data);
    //       })
    //       .catch((error) => {
    //         if (error.code == "TOKEN_MISSING") {
    //           resolve(null);
    //         } else {
    //           ElNotification({
    //             title: "失败",
    //             message: error,
    //             type: "error",
    //             duration: 3000,
    //           });
    //         }
    //       });
    //   });
    // };

    // const getActivityData = async () => {
    //   let browserData = await getActivityBrowser(activityBrowserRO, true);
    //   activityBrowserData.length = 0;
    //   if (browserData != null) {
    //     activityBrowserData.push(...browserData);
    //   }

    //   endActivityBrowserData.length = 0;
    //   endActivityYearData.length = 0;

    //   let yearData = await getEndActivityYear(activityBrowserRO, true);
    //   if (yearData != null && yearData.length > 0) {
    //     endActivityYearData.push(...yearData);

    //     selectActivityYear.value = yearData[0].activityYear;
    //     let endBrowserData = await getActivityBrowser(
    //       {
    //         searchKeyword: activityBrowserRO.searchKeyword,
    //         activityYear: yearData[0].activityYear,
    //       },
    //       true
    //     );

    //     endActivityBrowserData.push(...endBrowserData);
    //   }
    // };

    ///////////////////////////
    const activityStatsYearRO = reactive({
      searchKeyword: null,
      activityStatsTypeId: null
    });
    const activityStatsData = reactive({
      ongoingItems: [],
      years: []
    });
    onMounted(async () => {
      await loadActivityData();
    });
    const loadActivityData = async () => {
      let browserDataPre = await getActivityBrowserPre(activityBrowserRO, true);
      activityData.ongoingItems.length = 0;
      if (Array.isArray(browserDataPre.ongoingItems)) {
        activityData.ongoingItems.push(...browserDataPre.ongoingItems.filter(item => item.activityId != 51));
      }
      let browserData = await getActivityBrowser(activityBrowserRO, true);
      activityData.ongoingItems.length = 0;
      if (Array.isArray(browserData.ongoingItems)) {
        activityData.ongoingItems.push(...browserData.ongoingItems.filter(item => item.activityId != 51));
      }
      activityData.years.length = 0;
      let browserData2 = await getActivityBrowser(activityBrowserRO2, true);
      console.log(browserData2);
      if (Array.isArray(browserData2.completedItems)) {
        for (let item of browserData2.completedItems) {
          if (item.activityId == 51) {
            continue;
          }
          let year = item.activityBegin.substring(0, 4);
          let findIndex = activityData.years.findIndex(element => element.yearName == year + "");
          if (findIndex != -1) {
            let yearObject = activityData.years[findIndex];
            yearObject.completedItems.push(item);
          } else {
            let yearObject = {
              yearName: year + "",
              completedItems: []
            };
            yearObject.completedItems.push(item);
            activityData.years.push(yearObject);
          }
        }
      }
      activityData.years.sort((a, b) => {
        // 对 yearName 进行比较，降序排序
        return b.yearName.localeCompare(a.yearName);
      });
      activeIndex.value = activityData.years.length > 0 ? 0 : -1;
    };
    const getActivityStatsYearRequest = async activityStatsYearRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsYear(activityStatsYearRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const items = reactive([{
      title: "2024",
      content: "This is the content of Panel 1"
    }, {
      title: "2025",
      content: "This is the content of Panel 2"
    }, {
      title: "2026",
      content: "This is the content of Panel 3"
    }]);
    const collapseSize = reactive({});
    // var collapseTransition = false;

    const activeIndex = ref(0);
    const onActivityCategoryChange = value => {
      activityBrowserRO.activityCategoryId = value;
      loadActivityData();
    };
    const onSearch = () => {
      loadActivityData();
    };
    const toggle = index => {
      if (index == activeIndex.value) {
        return;
      }
      // collapseTransition = true;
      activeIndex.value = index;
    };
    const onPaneSizeChange = (size, sign) => {
      // collapseTransition = false;
      if (!collapseSize[sign]) {
        collapseSize[sign] = {};
      }
      collapseSize[sign].width = size.width;
      collapseSize[sign].height = size.height;
      console.log(size, sign);
    };
    const getHeaderItemStyle = index => {
      if (!collapseSize[index]) {
        return;
      }
      let style = {};
      if (index <= activeIndex.value) {
        style.transform = `translateY(${index * 23 + 30}px)`;
      } else {
        style.transform = `translateY(${collapseSize[activeIndex.value].height - (items.length - index) * 23}px)`;
      }
      // if (collapseTransition) {
      style.transition = "transform 0.3s ease";
      // }
      return style;
    };
    const getActivityItemTextStyle = item => {
      let style = {};
      if (item.activityWeekName === "365" || item.activityCategoryId === 2 || item.activityCategoryId === 4) {
        if (item.progress >= 50) {
          style.color = `white`;
        } else {
          style.color = `#E3788C`;
        }
      } else {
        if (item.progress >= 50) {
          style.color = `black`;
        } else {
          style.color = `#E3788C`;
        }
      }
      return style;
    };
    const getActivityItemProgressStyle = (item, type) => {
      let style = {};
      if (type == 1) {
        if (item.progress >= 50) {
          style["0%"] = "#447AE2";
          style["100%"] = "#29ABE2";
        } else {
          style["0%"] = "#E24446";
          style["100%"] = "#E22AB7";
        }
        return style;
      }
      if (type == 2) {
        if (item.progress >= 50) {
          style["0%"] = "#005fea";
          style["100%"] = "#00c2fa";
        } else {
          style["0%"] = "#E24446";
          style["100%"] = "#E22AB7";
        }
        return style;
      }
      if (type == 3) {
        if (item.progress >= 50) {
          style["0%"] = "#5b6fd4";
          style["100%"] = "#49c5ef";
        } else {
          style["0%"] = "#E24446";
          style["100%"] = "#E22AB7";
        }
        return style;
      }
      if (type == 4) {
        if (item.progress >= 50) {
          style["0%"] = "#6a92c8";
          style["100%"] = "#c2dlec";
        } else {
          style["0%"] = "#E24446";
          style["100%"] = "#E22AB7";
        }
        return style;
      }
    };
    const getActivityItemBackgroundStyle = item => {
      let style = {};
      if (item.activityWeekName === "365" || item.activityCategoryId === 2 || item.activityCategoryId === 4) {
        style.backgroundColor = `black`;
      } else if (item.activityCategoryId === 3) {
        style.backgroundColor = `DarkGray `;
      } else {
        style.backgroundColor = `white`;
      }
      if (permission.havePermission("活动管理", "活动详情")) {
        style.cursor = "pointer";
      }
      return style;
    };
    const getActivityItemTitleStyle = item => {
      let style = {};
      if (item.activityWeekName === "365" || item.activityCategoryId === 2 || item.activityCategoryId === 4) {
        style.color = `white`;
      } else if (item.activityCategoryId === 3) {
        style.color = `white `;
      } else {
        style.color = `black`;
      }
      return style;
    };
    const getContentItemStyle = index => {
      if (!collapseSize[index]) {
        return;
      }
      let style = {};
      if (index <= activeIndex.value) {
        style.transform = `translateY(0px)`;
      } else {
        style.transform = `translateY(${collapseSize[activeIndex.value].height - (items.length - index) * 23 + 12}px)`;
      }
      // if (index === activeIndex.value) {
      //   style.height = `${
      //     collapseSize[index].height - (items.length - 1 - index) * 23
      //   }px`;
      // }
      // if (collapseTransition) {
      style.transition = "transform 0.3s ease";
      // }
      return style;
    };
    const activityCreateClick = () => {
      router.push({
        path: "/activity-create"
      });
    };
    const activityClick = activityId => {
      if (permission.havePermission("活动管理", "活动详情")) {
        router.push({
          path: "/activity-detail/" + activityId
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_space = _resolveComponent("a-space");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_progress = _resolveComponent("a-progress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(permission).havePermission('活动管理', '新建活动') ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: activityCreateClick,
        style: {
          "margin-left": "120px",
          "width": "80px",
          "height": "25px",
          "padding": "0"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("activityBrowser.create")), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_space, {
        size: "large"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([{
            active: activityBrowserRO.activityCategoryId === null
          }, "filter-button"]),
          onClick: _cache[0] || (_cache[0] = $event => onActivityCategoryChange(null))
        }, " All ", 2), _createElementVNode("div", {
          class: _normalizeClass([{
            active: activityBrowserRO.activityCategoryId === 4
          }, "filter-button"]),
          onClick: _cache[1] || (_cache[1] = $event => onActivityCategoryChange(4))
        }, " 365 ", 2), _createElementVNode("div", {
          class: _normalizeClass([{
            active: activityBrowserRO.activityCategoryId === 2
          }, "filter-button"]),
          onClick: _cache[2] || (_cache[2] = $event => onActivityCategoryChange(2))
        }, " Jordan ", 2), _createElementVNode("div", {
          class: _normalizeClass([{
            active: activityBrowserRO.activityCategoryId === 1
          }, "filter-button"]),
          onClick: _cache[3] || (_cache[3] = $event => onActivityCategoryChange(1))
        }, " Nike ", 2), _createElementVNode("div", {
          class: _normalizeClass([{
            active: activityBrowserRO.activityCategoryId === 3
          }, "filter-button"]),
          onClick: _cache[4] || (_cache[4] = $event => onActivityCategoryChange(3))
        }, " Value ", 2), _createVNode(_component_a_input_search, {
          value: activityBrowserRO.searchKeyword,
          "onUpdate:value": _cache[5] || (_cache[5] = $event => activityBrowserRO.searchKeyword = $event),
          placeholder: "input search text",
          style: {
            "width": "200px"
          },
          onSearch: onSearch
        }, null, 8, ["value"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.ongoingItems, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: _normalizeStyle(getActivityItemBackgroundStyle(item)),
          class: "activity-box",
          onClick: $event => _unref(permission).havePermission('活动管理', '活动详情') && activityClick(item.activityId)
        }, [item.activityWeekName === '365' || item.activityCategoryId === 4 ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          iconName: "365",
          iconSize: "60px",
          style: {
            "position": "absolute",
            "top": "0px",
            "right": "0px"
          }
        })) : _createCommentVNode("", true), _createElementVNode("img", {
          style: {
            "width": "280px",
            "height": "150px"
          },
          src: item.logoUrl != null ? item.logoUrl : require('@/assets/img/activityCoverDefault.png')
        }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
          class: "activity-title",
          style: _normalizeStyle(getActivityItemTitleStyle(item))
        }, _toDisplayString(item.activityWeekName) + _toDisplayString(item.activityWeekName != "365" ? (item.activityYear + "").substring(2, 4) : "") + " " + _toDisplayString(item.activityName), 5), item.totalQuantity === null ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "activity-title",
          style: _normalizeStyle([{
            "display": "flex",
            "flex-direction": "column",
            "font-family": "'SourceHanSansCN-Regular'",
            "font-size": "10px"
          }, getActivityItemTextStyle(item)])
        }, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_component_a_progress, {
          showInfo: false,
          "stroke-color": getActivityItemProgressStyle(item, 1),
          percent: item.installedProgress,
          style: {
            "margin-bottom": "0px"
          },
          trailColor: "#f0f0f0",
          status: "normal"
        }, null, 8, ["stroke-color", "percent"]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_a_progress, {
          showInfo: false,
          "stroke-color": getActivityItemProgressStyle(item, 2),
          percent: item.progress,
          style: {
            "margin-bottom": "0px"
          },
          trailColor: "#f0f0f0",
          status: "normal"
        }, null, 8, ["stroke-color", "percent"]), _hoisted_17])], 4)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "activity-title",
          style: _normalizeStyle([{
            "display": "flex",
            "flex-direction": "column",
            "font-family": "'SourceHanSansCN-Regular'",
            "font-size": "10px"
          }, getActivityItemTextStyle(item)])
        }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(item.installedProgress) + "% ", 1), _createVNode(_component_a_progress, {
          showInfo: false,
          "stroke-color": getActivityItemProgressStyle(item, 1),
          percent: progressAnimated[item.activityId] || 0,
          style: {
            "margin-bottom": "0px"
          },
          trailColor: "#f0f0f0",
          status: "normal"
        }, null, 8, ["stroke-color", "percent"]), _createElementVNode("div", null, _toDisplayString(item.installedQuantity) + "/" + _toDisplayString(item.totalQuantity), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(item.progress) + "% ", 1), _createVNode(_component_a_progress, {
          showInfo: false,
          "stroke-color": getActivityItemProgressStyle(item, 2),
          percent: progressAnimated[item.activityId] || 0,
          style: {
            "margin-bottom": "0px"
          },
          trailColor: "#f0f0f0",
          status: "normal"
        }, null, 8, ["stroke-color", "percent"]), _createElementVNode("div", null, _toDisplayString(item.quantity) + "/" + _toDisplayString(item.totalQuantity), 1)])], 4))])], 12, _hoisted_9);
      }), 128))])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.years, (year, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["collapse-header-item", {
            'active-header-item': index === activeIndex.value
          }]),
          style: _normalizeStyle(getHeaderItemStyle(index)),
          onClick: $event => toggle(index)
        }, _toDisplayString(year.yearName), 15, _hoisted_25);
      }), 128))]), _createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.years, (year, index) => {
        return _openBlock(), _createBlock(ResizePane, {
          sign: index,
          onPaneSizeChange: onPaneSizeChange,
          key: index,
          class: _normalizeClass([{
            active: index > activeIndex.value
          }, "collapse-content-item"]),
          style: _normalizeStyle(getContentItemStyle(index))
        }, {
          default: _withCtx(() => [index > activeIndex.value ? (_openBlock(), _createElementBlock("div", _hoisted_27)) : _createCommentVNode("", true), index === activeIndex.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(year.completedItems, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              style: _normalizeStyle(getActivityItemBackgroundStyle(item)),
              class: "activity-box",
              onClick: $event => _unref(permission).havePermission('活动管理', '活动详情') && activityClick(item.activityId)
            }, [item.activityWeekName === '365' || item.activityCategoryId === 4 ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              iconName: "365",
              iconSize: "60px",
              style: {
                "position": "absolute",
                "top": "0px",
                "right": "0px"
              }
            })) : _createCommentVNode("", true), _createElementVNode("img", {
              style: {
                "width": "280px",
                "height": "150px"
              },
              src: item.logoUrl != null ? item.logoUrl : require('@/assets/img/activityCoverDefault.png')
            }, null, 8, _hoisted_30), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
              class: "activity-title",
              style: _normalizeStyle(getActivityItemTitleStyle(item))
            }, _toDisplayString(item.activityWeekName) + _toDisplayString((item.activityYear + "").substring(2, 4)) + " " + _toDisplayString(item.activityName), 5), _createElementVNode("div", {
              class: "activity-title",
              style: _normalizeStyle([{
                "display": "flex",
                "flex-direction": "column",
                "font-family": "'SourceHanSansCN-Regular'",
                "font-size": "10px"
              }, getActivityItemTextStyle(item)])
            }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(item.installedProgress) + "% ", 1), _createVNode(_component_a_progress, {
              showInfo: false,
              "stroke-color": getActivityItemProgressStyle(item, 3),
              percent: item.installedProgress,
              style: {
                "margin-bottom": "0px"
              },
              trailColor: "#f0f0f0",
              status: "normal"
            }, null, 8, ["stroke-color", "percent"]), _createElementVNode("div", null, _toDisplayString(item.installedQuantity) + "/" + _toDisplayString(item.totalQuantity), 1)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(item.progress) + "% ", 1), _createVNode(_component_a_progress, {
              showInfo: false,
              "stroke-color": getActivityItemProgressStyle(item, 4),
              percent: item.progress,
              style: {
                "margin-bottom": "0px"
              },
              trailColor: "#f0f0f0",
              status: "normal"
            }, null, 8, ["stroke-color", "percent"]), _createElementVNode("div", null, _toDisplayString(item.quantity) + "/" + _toDisplayString(item.totalQuantity), 1)])], 4)])], 12, _hoisted_29);
          }), 128))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.years.length - 1 - index, (box, index1) => {
            return _openBlock(), _createElementBlock("div", {
              key: index1,
              style: {
                "width": "1",
                "height": "23px"
              }
            });
          }), 128))]),
          _: 2
        }, 1032, ["sign", "class", "style"]);
      }), 128))])])])])]);
    };
  }
};